import { Injectable } from '@angular/core';

@Injectable()
export class RedirectService {

    post(obj, url) {
        const mapForm = document.createElement('form');
        mapForm.method = 'POST';
        mapForm.action = url;
        mapForm.enctype = 'application/x-www-form-urlencoded';
        Object.keys(obj).forEach(function(param) {
            const mapInput = document.createElement('input');
            mapInput.type = 'hidden';
            mapInput.name = param;
            mapInput.setAttribute('value', obj[param]);
            mapForm.appendChild(mapInput);
        });
        document.body.appendChild(mapForm);
        mapForm.submit();
    }

}
